<template>
  <el-dialog
    id="push-to-yuanshou"
    :class="showTips ? 'push-to-yuanshou' : 'push-to-yuanshou title-hide'"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    title="微名片职位发布"
    :modal="false"
    :append-to-body="true"
    :fullscreen="true"
    :show-close="false"
  >
    <div slot="title">
      <div style="text-align: left">只需3步，打造有吸引力的职位，让更多候选人主动来找你~</div>
      <div class="yuanshou-steps">
        <div class="yuanshou-step">
          <div class="yuanshou-step-box">第一步：确认职位基本信息</div>
          <div class="yuanshou-step-word">关键点：<br />1、分享猎头职位时不能暴露公司名称，需再次确认</div>
        </div>
        <div class="yuanshou-step">
          <div class="yuanshou-step-box">第二步：编辑职位吸引点</div>
          <div class="yuanshou-step-word">
            关键点：<br />1、突出职位亮点，吸引候选人<br />2、可参考其他小伙伴是怎么写的
          </div>
        </div>
        <div class="yuanshou-step">
          <div class="yuanshou-step-box">第三步：扫码分享候选人</div>
          <div class="yuanshou-step-word">关键点：<br />1、需关注公众号“圆手查薪酬”，不能取关</div>
        </div>
        <div class="yuanshou-step">
          <div class="yuanshou-step-box">完成：坐等简历飞来</div>
        </div>
      </div>
      <div
        @click="showTips = !showTips"
        class="more"
      >
        <span>{{ showTips ? '收起' : '展开' }}</span>
        <i :class="showTips ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
      </div>
    </div>
    <div :class="showTips ? 'yuanshou-main' : 'yuanshou-main yuanshou-main-hide'">
      <div
        class="yuanshou-box"
        style="margin-bottom: 15px"
      >
        <div class="yuanshou-input-title">基本信息确认</div>
        <el-row
          class="yuanshou-input-content"
          v-if="ifGuanliyuan"
        >
          <el-col
            :span="12"
            class="yuanshou-input-item"
          >
            <div class="yuanshou-input-label"><b>*</b>该职位所属猎头：</div>
            <el-select
              class="input-main"
              v-model="formatProject.hunterId"
              placeholder="请选择该职位所属猎头"
              multiple
              @change="getHunterInfo"
            >
              <el-option
                v-for="item in allHunter"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <!-- <div v-if="!review">
              <span v-for="(item, idx) in formatProject.hunterId" :key="idx">{{ item }}{{ idx === formatProject.hunterId.length - 1 ? '' : '，' }}</span>
            </div>
            <div v-else>
              <span v-for="(item, idx) in formatProject.所有顾问" :key="idx">{{ item }}{{ idx === formatProject.所有顾问.length - 1 ? '' : '，' }}</span>
            </div> -->
            <!-- <div class="yuanshou-tips" v-if="!review">发布后这个职位会属于你选择的猎头</div> -->
          </el-col>
        </el-row>
        <el-row class="yuanshou-input-content">
          <el-col
            :span="12"
            :class="'yuanshou-input-item ' + (failText.includes('标题') ? 'fail ' : ' ') + (warningText.includes('标题') ? 'warning ' : ' ')"
          >
            <div
              class="yuanshou-input-label"
              :data-failObj="`存在以下敏感词:${failObj.标题},请确认修改后重试`"
              :data-warningObj="`${failObj.标题?'':`存在以下疑似敏感词:${warningObj.标题},请确认是否需要修改`}`"
            ><b>*</b>职位名称：</div>
            <el-input
              class="input-main"
              v-model="formatProject.标题"
              data-name="标题"
              @blur="checkCompany"
            ></el-input>
            <div class="yuanshou-tips">岗位名称：默认来自核心系统，可自行修改</div>
          </el-col>
          <el-col
            :span="12"
            class="yuanshou-input-item"
          >
            <div class="yuanshou-input-label"><b>*</b>薪资待遇：</div>
            <div class="yuanshou-input-group">
              <el-input
                class="input-main-mini"
                v-model="formatProject.月薪范围[0]"
                placeholder="请输入薪酬下限"
                v-if="!ifMianyi"
              >
                <template slot="append">K</template>
              </el-input>
              <span
                v-if="!ifMianyi"
                style="margin: 0 5px"
              >—</span>
              <el-input
                class="input-main-mini"
                v-model="formatProject.月薪范围[1]"
                placeholder="请输入薪酬上限"
                v-if="!ifMianyi"
              >
                <template slot="append">K</template>
              </el-input>
              <span
                v-if="!ifMianyi"
                style="margin: 0 5px"
              >×</span>
              <el-input
                class="input-main-mini"
                v-model="formatProject.月数"
                placeholder="请输入薪酬月数"
                style="margin-right: 10px"
                v-if="!ifMianyi"
              >
                <template slot="append">月</template>
              </el-input>
              <el-checkbox v-model="ifMianyi">面议</el-checkbox>
            </div>
            <div class="yuanshou-tips">如果不知到具体薪酬，勾选面议</div>
          </el-col>
        </el-row>
        <div class="yuanshou-input-title">客户信息确认</div>
        <el-row class="yuanshou-input-content">
          <el-col :span="12">
            <div :class="'yuanshou-input-item ' + (failText.includes('公司') ? 'fail ' : ' ') + (warningText.includes('公司') ? 'warning' : '')">
              <div
                class="yuanshou-input-label"
                :data-failObj="`存在以下敏感词:${failObj.公司},请确认修改后重试`"
                :data-warningObj="`${failObj.公司?'':`存在以下疑似敏感词:${warningObj.公司},请确认是否需要修改`}`"
              >
                客户公司：{{ rawProject.客户公司 || formatProject.公司名称 || formatProject.公司全称 }}
                <span class="yuanshou-tips yuanshou-tips-red">（不公开展示真实名称）</span>
              </div>
              <el-input
                class="input-main"
                v-model="formatProject.公司"
                data-name="公司"
                @blur="checkCompany"
              ></el-input>
              <div class="yuanshou-tips">公司名称系统自动生成，可自行修改</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="yuanshou-input-item">
              <div class="yuanshou-input-label">
                公司亮点：
                <span class="yuanshou-tips yuanshou-tips-red">（下拉选择，可多选）</span>
              </div>
              <el-select
                class="input-main"
                v-model="formatProject.职位亮点"
                filterable
                placeholder="请选择职位亮点"
                multiple
              >
                <el-option
                  v-for="item in liangs"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              <div class="yuanshou-tips">默认来自系统客户公司，可修改</div>
            </div>
          </el-col>
          <!-- <el-col :span="24">
            <div class="yuanshou-input-item">
              <div class="yuanshou-input-label">一句话介绍：</div>
              <el-input
                class="input-main"
                v-model="formatProject.一句话简介"
                data-name="一句话简介"
              ></el-input>
            </div>
          </el-col> -->
        </el-row>
        <div class="yuanshou-input-title">岗位要求确认</div>
        <el-row class="yuanshou-input-content">
          <el-col
            :span="8"
            class="yuanshou-input-item"
          >
            <div class="yuanshou-input-label"><b>*</b>工作地：</div>
            <el-select
              class="input-main"
              v-model="formatProject.城市"
              filterable
              placeholder="请选择工作地"
              multiple
              :multiple-limit="3"
            >
              <el-option
                v-for="item in citys"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-col>
          <el-col
            :span="8"
            class="yuanshou-input-item"
          >
            <div class="yuanshou-input-label"><b>*</b>工作经验：</div>
            <div class="yuanshou-input-group">
              <el-input
                v-if="!ifYearBuxian"
                class="input-main-mini"
                v-model="formatProject.工作经验[0]"
              >
                <template slot="append">年</template>
              </el-input>
              <span
                v-if="!ifYearBuxian"
                style="margin: 0 5px"
              >—</span>
              <el-input
                v-if="!ifYearBuxian"
                class="input-main-mini"
                v-model="formatProject.工作经验[1]"
                style="margin-right: 10px"
              >
                <template slot="append">年</template>
              </el-input>
              <el-checkbox v-model="ifYearBuxian">不限</el-checkbox>
            </div>
          </el-col>
          <el-col
            :span="8"
            class="yuanshou-input-item"
          >
            <div class="yuanshou-input-label"><b>*</b>学历要求：</div>
            <el-select
              class="input-main"
              v-model="formatProject.学历要求"
              placeholder="请选择学历"
            >
              <el-option
                v-for="item in grades"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-col>
          <el-col
            :span="8"
            class="yuanshou-input-item"
          >
            <div class="yuanshou-input-label"><b>*</b>行业：</div>
            <el-select
              class="input-main"
              v-model="formatProject.圆手行业"
              placeholder="请选择行业"
              @change="onIndustriesChange"
            >
              <el-option
                v-for="item in industries"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <div class="yuanshou-tips">默认来自客户公司，可根据项目要求直接修改</div>
          </el-col>
          <el-col
            :span="16"
            class="yuanshou-input-item"
          >
            <div class="yuanshou-input-label">
              <b>*</b>职能模块：
              <span class="yuanshou-tips">点击选择该职位的职能类型，以方便人选匹配和搜索</span>
            </div>
            <div
              class="input-wrap"
              @click="showSelectNewCategoryDetail"
            >
              <el-tag
                v-for="item in formatProject.新圆手细分职能"
                :key="item"
                size="small"
                type="info"
                :closable="true"
                @close="removeCategory(item)"
                style="margin: 2px"
              >{{ item }}</el-tag>
              <div
                v-if="!formatProject.新圆手细分职能 || formatProject.新圆手细分职能.length === 0"
                @click="showSelectNewCategoryDetail"
                style="flex-grow: 1"
              ></div>
              <i
                class="el-icon-menu more"
                style="cursor: pointer"
                @click="showSelectNewCategoryDetail"
              ></i>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="yuanshou-box">
        <div class="yuanshou-input-content">
          <div
            :class="'yuanshou-input-item ' + (failText.includes('职位吸引点') ? 'fail ' : ' ')+ (warningText.includes('职位吸引点') ? 'warning' : '')"
            style="width: 100%"
          >
            <div
              class="yuanshou-input-label"
              :data-failObj="`存在以下敏感词:${failObj.职位吸引点},请确认修改后重试`"
              :data-warningObj="`${failObj.职位吸引点?'':`存在以下疑似敏感词:${warningObj.职位吸引点},请确认是否需要修改`}`"
            >
              职位吸引点：
              <span class="yuanshou-tips">默认来自项目亮点与优势，可根据项目要求直接修改</span>
              <span
                class="yuanshou-text-btn yuanshou-icon-text"
                @click="showXiyin"
              >
                <i
                  class="iconfont icon-view"
                  style="margin: 0 3px 0 10px"
                ></i>看看别人怎么写
              </span>
            </div>
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              data-name="职位吸引点"
              class="input-main"
              v-model="formatProject.职位吸引点"
              placeholder="请输入职位吸引点"
              @blur="checkCompany"
            ></el-input>
          </div>
          <div :class="'yuanshou-input-item ' + (failText.includes('职位描述') ? 'fail ' : '') + (warningText.includes('职位描述') ? 'warning' : '')">
            <div
              class="yuanshou-input-label"
              :data-failObj="`存在以下敏感词:${failObj.职位描述},请确认修改后重试`"
              :data-warningObj="`${failObj.职位描述?'':`存在以下疑似敏感词:${warningObj.职位描述},请确认是否需要修改`}`"
            >
              <b>*</b>职位描述：
              <span class="yuanshou-tips">来自岗位职责+岗位要求</span>
              <span
                class="yuanshou-text-btn yuanshou-icon-text"
                @click="showMiaoshu"
              >
                <i
                  class="iconfont icon-view"
                  style="margin: 0 3px 0 10px"
                ></i>样例模板
              </span>
            </div>
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              class="input-main"
              v-model="formatProject.职位描述"
              data-name="职位描述"
              placeholder="请输入职位JD"
              @blur="checkCompany"
            ></el-input>
          </div>
        </div>
      </div>
    </div>
    <div :class="showTips ? 'yuanshou-preview' : 'yuanshou-preview yuanshou-preview-hide'">
      <div class="job-detail">
        <div class="job-detail-row">
          <div class="job-title">{{ formatProject['标题'] }}</div>
          <div class="job-salary">
            <span v-if="
                (formatProject['月薪范围'][0] == 0 && formatProject['月薪范围'][1] == 0) ||
                formatProject['月薪范围'][0] === '面议' ||
                formatProject['月薪范围'] === '面议'
              ">面议</span>
            <span v-else>{{ formatProject['月薪范围'][0]
              }}{{ formatProject['月薪范围'][1] ? '-' + formatProject['月薪范围'][1] : '' }}k/月</span>
          </div>
        </div>
        <div class="job-detail-row">
          <div class="job-tags">
            <span
              v-for="(city, cityidx) in formatProject['城市']"
              :key="cityidx"
            >{{ city }}{{ cityidx === formatProject['城市'].length - 1 ? '' : '、' }}</span>
            /
            <span v-if="formatProject['工作经验'] === '不限'">工作经验不限</span>
            <span v-else-if="formatProject['工作经验'] && formatProject['工作经验'][0] && formatProject['工作经验'][1]">{{ formatProject['工作经验'][0] }}-{{ formatProject['工作经验'][1] }}年工作经验</span>
            <span v-else-if="formatProject['工作经验'] && formatProject['工作经验'][0]">{{ formatProject['工作经验'][0] }}年及以上</span>
            <span v-else>工作经验不限</span>
            /
            {{ formatProject['学历要求'] || '本科' }}
            /
            {{ formatProject['职位性质'] || '社会招聘' }}
          </div>
          <div
            class="job-tags"
            v-if="formatProject['发布时间']"
          >
            {{ formatProject['发布时间'] }}
          </div>
        </div>
      </div>
      <div class="company-info">
        <div class="company-title">{{ formatProject['公司'] }}-由猎头发布</div>
        <!-- <div class="company-desc">{{formatProject["一句话简介"]}}</div> -->
        <div class="job-detail-tags">
          <div
            class="job-detail-tag"
            v-for="(item, idx) in formatProject['职位亮点']"
            :key="idx"
          >{{ item }}</div>
        </div>
      </div>
      <div class="desc" v-if="formatProject['职位吸引点']">
        <div class="desc-title">职位吸引点</div>
        <div class="company-content">{{ formatProject['职位吸引点'] || '' }}</div>
      </div>
      <div class="desc">
        <div class="desc-title">职位描述</div>
        <div class="desc-content">{{ formatProject['职位描述'] }}</div>
      </div>
      <div class="desc">
        <div class="desc-title">关键要求</div>
        <div class="desc-yaoqiu-wrap">
          <div class="desc-yaoqiu-item"><b>学历要求： </b>{{ formatProject['学历要求'] || '本科' }}</div>
          <div class="desc-yaoqiu-item">
            <b>工作地点： </b>
            <span
              v-for="(city, cityidx) in formatProject['城市']"
              :key="cityidx"
            >{{ city }}{{ cityidx === formatProject['城市'].length - 1 ? '' : '、' }}</span>
          </div>
          <div class="desc-yaoqiu-item">
            <b>工作年限： </b>
            <span v-if="formatProject['工作经验'] && formatProject['工作经验'][0] && formatProject['工作经验'][1]">{{ formatProject['工作经验'][0] }}-{{ formatProject['工作经验'][1] }}年</span>
            <span v-else-if="formatProject['工作经验'] && formatProject['工作经验'][0]">{{ formatProject['工作经验'][0] }}年及以上</span>
            <span v-else>工作经验不限</span>
          </div>
          <div class="desc-yaoqiu-item"><b>职位类型： </b>{{ formatProject['职位性质'] || '社会招聘' }}</div>
        </div>
      </div>
      <div class="card">
        <div class="company-title">职位顾问</div>
        <div class="card-wrap">
          <div class="card-icon">
            <img
              :src="hunterInfo.avatar"
              alt=""
            />
          </div>
          <div class="card-info">
            <div class="card-name">
              {{ hunterInfo.name }}
              <div class="card-wechat">
                <img
                  src="./wechat.png"
                  alt=""
                />
              </div>
            </div>
            <div
              class="card-desc"
              v-if="hunterInfo.goodat && hunterInfo.goodat.length > 0"
            >
              <span
                v-for="(item, idx) in hunterInfo.goodat"
                :key="idx"
              >{{ item }}<span
                  v-if="idx !== hunterInfo.goodat.length - 1"
                  style="margin: 0 10rpx"
                >|</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <span>是否设置为公开职位：</span>
      <el-switch v-model="ifPublic"> </el-switch>
      &nbsp;&nbsp;&nbsp;
      <el-button
        @click="push"
        type="primary"
        size="small"
      >发布</el-button>
      <el-button
        @click="dialogVisible = false"
        type="info"
        size="small"
      >取消</el-button>
    </div>
    <el-dialog
      :visible.sync="innerDialogVisible"
      title="已发布成功"
      :modal="false"
      :append-to-body="true"
      width="410px"
      top="0"
      class="push-inner-dia"
    >
      <div style="background: #e8f3f9; padding: 10px 20px">
        <div style="position: relative; margin: 0 -10px">
          <img
            src="./building.png"
            style="width: 100%; border-radius: 5px"
          />
          <div style="position: absolute; top: 30px; left: 30px; right: 30px; font-size: 24px; color: #fff">
            {{ formatProject['公司'] }}
          </div>
          <div style="
              position: absolute;
              top: 70px;
              left: 30px;
              right: 30px;
              font-size: 30px;
              color: #fff;
              font-weight: bold;
            ">
            {{ formatProject['标题'] }}
          </div>
          <div style="
              position: absolute;
              top: 110px;
              left: 10px;
              right: 30px;
              color: rgb(255, 255, 255);
              padding: 10px 20px;
              line-height: 1.5;
            ">
            <span
              v-for="(city, cityidx) in formatProject['城市']"
              :key="cityidx"
            >{{ city }}{{ cityidx === formatProject['城市'].length - 1 ? '' : ',' }}</span>
            |
            <span v-if="formatProject['工作经验'] && formatProject['工作经验'][0] && formatProject['工作经验'][1]">{{ formatProject['工作经验'][0] }}-{{ formatProject['工作经验'][1] }}年工作经验</span>
            <span v-else-if="formatProject['工作经验'] && formatProject['工作经验'][0]">{{ formatProject['工作经验'][0] }}年及以上</span>
            <span v-else>工作经验不限</span>
            |
            {{ formatProject['学历要求'] || '本科' }}
            |
            {{ formatProject['职位性质'] || '社会招聘' }}
          </div>
        </div>
        <div style="
            background: #e8f3f9;
            border-radius: 5px;
            box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 10px 2px;
            position: relative;
            top: -20px;
            padding: 20px 10px 10px 10px;
          ">
          <div style="
              background: #34457c;
              color: #fff;
              font-size: 20px;
              position: relative;
              left: -15px;
              box-shadow: rgba(50, 50, 50, 0.1) 5px 5px 1px 0;
              margin: 10px 0;
              padding: 7px 30px;
              display: inline-block;
            ">
            职位要求
          </div>
          <div style="color: #34457c; padding: 10px 20px; line-height: 1.5; white-space: pre-wrap; word-break: break-all">{{ formatProject['职位描述'] || '' }}</div>
          <div style="display: flex; padding: 10px 5px">
            <img
              :src="MpCode"
              style="width: 80px; height: 80px; margin-right: 10px"
            />
            <div style="flex: 1; display: flex; flex-direction: column; justify-content: center">
              <div style="
                  color: #34457c;
                  padding: 5px 0;
                  font-size: 14px;
                  font-weight: bold;
                  border-bottom: 1px solid #ddd;
                ">
                圆手招聘小程序
              </div>
              <div style="color: #999; padding: 5px 0; font-size: 12px">长按识别小程序/即可了解更多职位信息</div>
            </div>
          </div>
        </div>
        <img
          src="./cut.png"
          style="width: 100%; margin: 5px 0"
        />
        <div style="text-align: center">
          <div style="padding: 5px 0; color: #34457c; font-size: 12px">
            1.可扫描小程序码进入职位详情分享给候选人
            <br />
            2.亦可沿上方虚线截图，将职位海报发送给候选人
          </div>
          <span
            @click="
              () => {
                innerDialogVisible = false
                dialogVisible = false
              }
            "
            style="
              display: inline-block;
              background: #34457c;
              color: #fff;
              border-radius: 5px;
              padding: 8px 25px;
              margin: 10px;
            "
          >确定</span>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="exampleVisible"
      :title="exampleTitle"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal="false"
      custom-class="custom-dialog"
    >
      <div
        slot="title"
        class="title"
      >
        <div class="title-name">{{ exampleTitle }}</div>
        <div class="side-title"></div>
        <div class="handle-btn"></div>
      </div>
      <div v-if="exampleTitle === '职位吸引点'">
        <div class="example-title">可选择以下模板，再自行修改</div>
        <div
          class="example-wrap"
          v-for="(item, idx) in xiyin"
        >
          <span class="adv-idx">{{ idx + 1 }}</span>
          <p>{{ item }}</p>
          <el-button
            type="primary"
            size="small"
            class="adv-button"
            @click="chooseXiyin(item)"
          >应用此模板</el-button>
        </div>
      </div>
      <div v-if="exampleTitle === '职位描述'">
        <el-row style="margin-bottom:10px">
          <el-col :span="4">职能模块</el-col>
          <el-col :span="20">
            <el-select
              class="input-main"
              size="small"
              filterable
              v-model="JdCate"
              placeholder="请选择职能模块"
              @change="onJdCateChange"
            >
              <el-option
                v-for="item in JdCates"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row style="margin-bottom:10px">
          <el-col :span="4">细分职能</el-col>
          <el-col :span="20">
            <el-tag
              style="cursor:pointer;margin-right:10px"
              :effect="JdCateDetail===item.name?'dark':'plain'"
              @click="onJdCateDetailChange(item)"
              v-for="(item,idx) in JdCateDetails"
              :key="idx"
            >{{item.name}}</el-tag>
          </el-col>
        </el-row>
        <el-row
          class="jd-content-wrap"
          style="margin-bottom:10px"
        >{{JdExampleContent}}</el-row>
        <el-row
          type="flex"
          style="justify-content:center"
        >
          <el-button
            type="primary"
            size="small"
            class="adv-button"
            @click="chooseMiaoshu(JdExampleContent)"
          >一键填入</el-button>
        </el-row>
      </div>
    </el-dialog>
    <selectNewCategoryDetail
      ref="selectNewCategoryDetail"
      @confirm="handleSelectNewCategoryDetail"
    ></selectNewCategoryDetail>
  </el-dialog>
</template>
<script>
import selectNewCategoryDetail from '../../../../company/src/hunting/selectNewCategoryDetail.vue'
import { 公募基金, 证券公司, 信托公司, PEVC } from '../../constant/categories'
import { BaseUrl } from '../../../../misc/src/weimingpian.js'
import { JdExample } from '../../../../misc/src/JdExample.js'
const baseUrl = BaseUrl
// const baseUrl = `https://nenglijihe.hewa.cn`
// const baseUrl = `http://39.107.92.53:4747`
// const baseUrl = `http://192.168.10.81:3000`
const functionData = { 公募基金, 证券: 证券公司, 信托: 信托公司, PEVC }
const formatProject = {
  标题: '',
  城市: [],
  公司: '',
  一句话简介: '',
  职位亮点: [],
  圆手行业: '',
  圆手职能: [],
  新圆手细分职能: [],
  学历要求: '',
  月薪范围: [0, 0],
  职位描述: '',
  职位吸引点: '',
  项目的亮点与优势: '',
  工作经验: [0, 0],
  月数: 12,
  官网: '',
  职位类别B: '猎头岗位',
}
let Allwords = []
export default {
  data() {
    return {
      loading: null,
      ifGuanliyuan: app.user.角色 && (app.user.角色.includes('微名片管理员') || app.user.角色.includes('管理员')),
      ifMianyi: false,
      ifYearBuxian: false,
      dialogVisible: false,
      review: false,
      liangs: ['股东实力强', '大平台', '固薪高', '激励机制好', '文化好', '人员整体素质高', '压力小', '稳定'],
      citys: ['北京', '上海', '广州', '深圳', '天津', '杭州', '香港'],
      industries: [
        '芯片设计',
        '芯片制造',
        'EDA',
        '封装测试',
        '半导体材料',
        'FA',
        '公募基金',
        '证券',
        '信托',
        'PEVC',
        '银行',
        '保险',
        '互联网',
        '医药医疗',
        '期货',
        '其他',
      ],
      categories: [],
      grades: ['专科', '本科', '硕士', '博士'],
      type: 'new',
      types: ['全职', '实习'],
      ifPublic: false,
      showTips: false,
      hunterId: [],
      hunterInfo: {},
      fail: [],
      warning: [],
      innerDialogVisible: false,
      MpCode: '',
      projectPrimission: [
        { name: '项目名称', showYuanshou: true },
        { name: '客户公司', showYuanshou: true },
        { name: '项目概况', showYuanshou: true },
        { name: '工作地点', showYuanshou: true },
        { name: '工作经验', showYuanshou: true },
        { name: '学历要求', showYuanshou: true },
        { name: '岗位职责', showYuanshou: true },
        { name: '岗位要求', showYuanshou: true },
        { name: '项目亮点优势', showYuanshou: false },
        { name: '客户名称', showYuanshou: false },
        { name: '阿尔法公司认知', showYuanshou: false },
        { name: '一句话介绍', showYuanshou: false },
        { name: '公司介绍', showYuanshou: false },
        { name: '公司亮点', showYuanshou: false },
        { name: '职位劣势及风险点', showYuanshou: false },
        { name: '部门信息', showYuanshou: false },
        { name: '阿尔法项目认知', showYuanshou: false },
        { name: '项目成员', showYuanshou: false },
        { name: '面试辅导', showYuanshou: false },
        { name: '必成单分析', showYuanshou: false },
        { name: '寻访要求', showYuanshou: false },
        { name: '项目辅导', showYuanshou: false },
        { name: '项目评分', showYuanshou: false },
      ],
      rawProject: {},
      formatProject: formatProject,
      newJobCategoryDetail: {},
      exampleVisible: false,
      exampleTitle: '',
      allHunter: [],
      xiyin: [
        '1.中后台，出差少，工作状态稳定。\n2.投行转投资的机会。',
        '1.大平台转投行的机会。\n2.薪酬可观，激励机制非常好。\n3.股东方结构干净，内部文化脚踏实地。\n4.发展空间大，learning curve陡峭。',
        '1.该细分领域业绩市场最强。\n2.券商薪酬最高之一。\n3.团队成员素质超高，直线领导人好能力强。',
      ],
      JdExample,
      JdCate: '',
      JdCateDetail: '',
      JdExampleContent: '',
      miaoshu: [
        '1、国内外正规院校本科及以上学历，专业不限；\n2、具有三年以上股票型基金或理财产品投资管理等相关从业经验，过往业绩优良；\n3、熟悉证券、金融、财务知识；具有证券从业资格。',
        '1.参与IPO、再融资、并购、债券等项目的市场开发、资源获取、前期策划、尽职调查、方案设计论证、具体实施等；\n2.负责项目的运作方案的制作、建议书的撰写；\n3.负责项目改制、申报文件的撰写和申报、项目现场的沟通和协调工作；\n4.负责项目后期的持续督导、与客户的长期关系维护等工作；\n5.积极对投行业务领域新问题、新产品、新趋势等进行研究、总结；\n6.部门安排的其他工作。',
        '职位描述：\n1.负责基金会计工作及FDD工作。\n2.收集报表、财务层面跟踪指标、财务尽调。\n3.需要具备和企业家打交道的能力。\n任职要求：\n1.四大TS/审计背景，入职时间希望尽快。\n2.TOP performance。\n3.prefer 踏实 接地气 有耐心的女生，85-92年。',
      ],
    }
  },
  watch: {
    ifMianyi(val) {
      if (val) {
        this.formatProject.月薪范围 = '面议'
      } else {
        this.formatProject.月薪范围 = [0, 0]
      }
    },
    ifYearBuxian(val) {
      if (val) {
        this.formatProject.工作经验 = [0, 0]
      } else {
        this.formatProject.工作经验 = [0, 0]
      }
    },
    async dialogVisible(val) {
      if (val) {
        if (Allwords && Allwords.length === 0) {
          const { data } = await app.service('project').getFilterWordsArray({})
          Allwords = data
        }
        this.fail = []
        this.warning = []
        if (this.rawProject && this.rawProject.职能模块) {
          this.onJdCateChange(this.rawProject.职能模块)
        }
      }
    },
  },
  computed: {
    JdCates() {
      return this.JdExample.map((j) => j.name)
    },
    JdCateDetails() {
      if (!this.JdCate) {
        return []
      }
      if (!this.JdExample.find((j) => j.name === this.JdCate)) {
        return []
      }
      return this.JdExample.find((j) => j.name === this.JdCate).children
    },
    failText() {
      return this.fail.map((f) => f.testName)
    },
    failObj() {
      const Obj = {}
      this.fail.forEach((f) => {
        if (Obj[f.testName] && !Obj[f.testName].includes(f.word)) {
          Obj[f.testName].push(f.word)
        } else {
          Obj[f.testName] = [f.word]
        }
      })
      return Obj
    },
    warningText() {
      return this.warning.map((w) => w.testName)
    },
    warningObj() {
      const Obj = {}
      this.warning.forEach((f) => {
        if (Obj[f.testName] && !Obj[f.testName].includes(f.word)) {
          Obj[f.testName].push(f.word)
        } else {
          Obj[f.testName] = [f.word]
        }
      })
      return Obj
    },
  },
  components: {
    selectNewCategoryDetail,
  },
  methods: {
    onJdCateChange(val) {
      this.JdCate = val
      if (this.JdCateDetails[0]) {
        this.JdExampleContent = this.JdCateDetails[0].content
        this.JdCateDetail = this.JdCateDetails[0].name
      }
    },
    onJdCateDetailChange(item) {
      this.JdCateDetail = item.name
      this.JdExampleContent = item.content
    },
    async getAllHunter(projectId) {
      this.allHunter = []
      let { result } = await app.service('wechat').getAllHunter()
      const project = await app.service('project').fetch(projectId)
      const AllHunter = [
        ...new Set(
          (project.客户开发 || []).concat(project.项目对接 || [], project.项目经理 || [], project.项目成员 || []),
        ),
      ]
      result.forEach((r) => {
        if (AllHunter.includes(r.account)) {
          this.allHunter.push(r.account)
        }
      })
    },
    showSelectNewCategoryDetail() {
      this.$refs.selectNewCategoryDetail.open(this.formatProject.新圆手细分职能 || [])
    },
    handleSelectNewCategoryDetail(e) {
      this.formatProject.新圆手细分职能 = e
      this.$forceUpdate()
    },
    removeCategory(item) {
      this.formatProject.新圆手细分职能 = this.formatProject.新圆手细分职能.filter((c) => c !== item)
      this.$forceUpdate()
    },
    async checkCompany(e, name) {
      let flag = true
      const { data } = await app.service('project').getFilterWordsArrayByCompany({
        name:
          this.rawProject.客户公司 ||
          this.formatProject.公司名称 ||
          this.formatProject.公司全称 ||
          this.formatProject.公司,
      })
      if (!data) {
        return true
      }
      if (data.length === 0) {
        flag = true
      }
      // const { result, msg } = await app
      //   .service('company')
      //   .getCompany(
      //     this.rawProject.客户公司 ||
      //       this.formatProject.公司名称 ||
      //       this.formatProject.公司全称 ||
      //       this.formatProject.公司,
      //   )
      // if (msg === '数据不存在') {
      //   return true
      // }
      const companyList = data
      let testText = ''
      let testName = ''
      if (typeof e === 'string') {
        testText = e
        testName = name
      } else {
        testText = e.target.value
        testName = e.target.dataset.name
      }
      this.fail = this.fail.filter((r) => r.testName !== testName)
      this.warning = this.warning.filter((r) => r.testName !== testName)
      if (testName === '标题' && testText.indexOf('保密') !== -1) {
        this.fail.push({ word: '保密', testName })
        flag = false
      }
      if (companyList && companyList.length) {
        for (let c of companyList) {
          if (testText.indexOf(c) !== -1) {
            this.fail.push({ word: c, testName })
            flag = false
          }
        }
      }
      if (Allwords && Allwords.length) {
        for (let a of Allwords) {
          if (testText.indexOf(a) !== -1) {
            this.warning.push({ word: a, testName })
            flag = false
          }
        }
      }
      return flag
    },
    async getHunterInfo() {
      let hunterIds = ['']
      if (this.review) {
        hunterIds =
          this.formatProject.所有顾问 && this.formatProject.所有顾问[0]
            ? this.formatProject.所有顾问
            : [app.user.account]
      } else {
        hunterIds =
          this.formatProject.hunterId && this.formatProject.hunterId[0]
            ? this.formatProject.hunterId
            : [app.user.account]
      }
      const { data } = await app.service('wechat').externalApi({
        path: '/api/jobs/getHunterInfos?hunterIds=' + JSON.stringify(hunterIds.filter(Boolean)),
        baseUrl,
        method: 'GET',
      })
      if (data && data.some((d) => d.hunterId === hunterIds[0])) {
        this.hunterInfo = data.find((d) => d.hunterId === hunterIds[0]).hunterInfo
      }
    },
    async show(project) {
      this.review = false
      this.formatProject = JSON.parse(JSON.stringify(formatProject))
      const { data } = await app.service('wechat').externalApi({
        path: '/api/jobs/checkJobDuplicate?coreProjectId=' + project._id,
        baseUrl,
        method: 'GET',
      })
      this.formatProject.hunterId = [
        ...new Set(
          (project.客户开发 || []).concat(project.项目对接 || [], project.项目经理 || [], project.项目成员 || []),
        ),
      ]
      await this.getHunterInfo()
      await this.getAllHunter(project._id)
      if (data&&data.job) {
        try {
          const res = await this.$confirm('该职位已发布为猎头微名片职位,是否自动填写之前已填写信息', '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            type: 'warning',
          })
          if (res && res === 'confirm') {
            this.dialogVisible = true
            this.type = 'new'
            this.formatProject = JSON.parse(JSON.stringify(data.job))
            if (this.formatProject.状态 === '已上线') {
              this.ifPublic = true
            } else {
              this.ifPublic = false
            }
            if (this.formatProject.月薪范围 !== '面议') {
              this.formatProject.月薪范围.map((n, idx) => {
                this.formatProject.月薪范围[idx] = parseInt(n) / 1000
              })
            } else {
              this.ifMianyi = true
            }
            return
          }
        } catch (err) {
          console.log(err)
        }
      }
      this.rawProject = {}
      this.rawProject = project
      this.dialogVisible = true
      this.type = 'new'
      this.ifPublic = false
      this.formatProject.标题 = project.项目名称 || ''
      this.formatProject.圆手行业 = project.行业 || (project.目标行业 && project.目标行业[0] ? project.目标行业[0] : '')
      this.formatProject.城市 = project.地域 || project.办公地 || []
      if (!this.formatProject.职位描述) {
        this.formatProject.职位描述 = project.岗位描述和岗位要求
          ? `岗位描述和岗位要求\n${project.岗位描述和岗位要求}`
          : ''
      }
      if (!this.formatProject.职位吸引点) {
        this.formatProject.职位吸引点 = project.职位亮点及优势 || ''
      }
      if (!this.formatProject.学历要求) {
        this.formatProject.学历要求 = project.学历要求 || ''
      }
      this.formatProject.coreProjectId = project._id
      if (project.客户公司) {
        const res = await app.service('company').getCompany({ 简称: project.客户公司 })
        if (res.status == 200) {
          if (res.result.公司亮点 && res.result.公司亮点.keywords) {
            const liang = []
            for (const key in res.result.公司亮点.keywords) {
              const val = res.result.公司亮点.keywords[key]
              if (val) liang.push(key)
            }
            this.formatProject.职位亮点 = liang
          }
          //某+【上市/合资/】+【平台类型（大型/中型）】+【行业】+公司
          const pingtaiMap = {
            A: '大型',
            B: '中型',
            '': '',
          }
          this.formatProject.公司 = `某${res.result.公司性质 || ''}${pingtaiMap[res.result.平台等级 || ''] || ''}${
            res.result.行业 || ''
          }公司`
          if (res.result.一句话简介) this.formatProject.一句话简介 = res.result.一句话简介
          if (res.result.平台等级) {
            this.formatProject.平台等级 = res.result.平台等级
          }
          if (res.result.公司亮点) {
            this.formatProject.公司亮点 = res.result.公司亮点
          }
          if (res.result.公司性质) {
            this.formatProject.公司性质 = res.result.公司性质
          }
          if (res.result.简称) {
            this.formatProject.简称 = res.result.简称
            this.formatProject.公司全称 = res.result.简称
          }
          if (res.result.公司名称) {
            this.formatProject.公司全称 = res.result.公司名称
          }
        }
      }

      // this.formatProject.城市 = project.项目名称
      // this.formatProject.城市 = project.项目名称
    },
    async edit(row, review = false) {
      this.dialogVisible = true
      this.review = review
      this.type = 'edit'
      this.formatProject = JSON.parse(JSON.stringify(row))
      await this.getHunterInfo()
      await this.getAllHunter(this.formatProject.coreProjectId)
      if (review) {
        this.formatProject.hunterId = this.allHunter
      }
      if (this.formatProject.状态 === '已上线' || review) {
        this.ifPublic = true
      } else {
        this.ifPublic = false
      }
      if (this.formatProject.月薪范围 !== '面议') {
        this.formatProject.月薪范围.map((n, idx) => {
          this.formatProject.月薪范围[idx] = parseInt(n) / 1000
        })
      } else if (!review) {
        this.ifMianyi = true
      }
    },
    async getMpCode(id) {
      const { data } = await this.$axios.get(
        // `http://39.107.92.53:4747/api/salaryNew/getMpCode?appid=wx4d717856feced5bf&scene=${id}&path=pages/newformatProject/main`,
        `${baseUrl}/api/salaryNew/getMpCode?appid=wx95c568c278aa6c7c&scene=${id}&path=pages/newJobDetail/main`,
      )
      this.MpCode = data.data.code
      this.innerDialogVisible = true
    },
    onIndustriesChange() {
      this.categories = functionData[this.formatProject.圆手行业] || []
    },
    async push() {
      // return this.innerDialogVisible = true
      // this.formatProject.hunterId = app.user.account
      this.formatProject.职位性质 = '全职'
      if (this.ifPublic) {
        this.formatProject.状态 = '已上线'
      } else {
        this.formatProject.状态 = '已下线'
      }
      this.formatProject.微名片状态 = '已上线'
      if (!this.formatProject.标题) {
        this.$alert('请填写标题', '提示', {
          confirmButtonText: '确定',
          callback: (action) => {},
        })
        return
      }
      if (!this.formatProject.城市 || !this.formatProject.城市.length) {
        this.$alert('请填写工作地', '提示', {
          confirmButtonText: '确定',
          callback: (action) => {},
        })
        return
      }
      if (!this.formatProject.公司) {
        this.$alert('请填写公司', '提示', {
          confirmButtonText: '确定',
          callback: (action) => {},
        })
        return
      }
      if (!this.formatProject.圆手行业) {
        this.$alert('请填写行业', '提示', {
          confirmButtonText: '确定',
          callback: (action) => {},
        })
        return
      }
      if (!this.formatProject.新圆手细分职能 || !this.formatProject.新圆手细分职能.length) {
        this.$alert('请填写职能', '提示', {
          confirmButtonText: '确定',
          callback: (action) => {},
        })
        return
      }
      if (!this.formatProject.学历要求) {
        this.$alert('请填写学历要求', '提示', {
          confirmButtonText: '确定',
          callback: (action) => {},
        })
        return
      }
      if (
        !this.formatProject.月薪范围 ||
        (this.formatProject.月薪范围[0] === 0 && this.formatProject.月薪范围[1] === 0)
      ) {
        this.$alert('请填写有效的月薪范围或者选择面议', '提示', {
          confirmButtonText: '确定',
          callback: (action) => {},
        })
        return
      }
      if (!this.formatProject.职位描述) {
        this.$alert('请填写职位描述', '提示', {
          confirmButtonText: '确定',
          callback: (action) => {},
        })
        return
      }
      // if (!this.formatProject.职位吸引点) {
      //   this.$alert('请填写职位吸引点', '提示', {
      //     confirmButtonText: '确定',
      //     callback: (action) => {},
      //   })
      //   return
      // }
      if (this.fail.length > 0) {
        this.$alert('请确认客户公司名是否能对外公开', '提示', {
          confirmButtonText: '确定',
          callback: (action) => {},
        })
        return
      }
      if (this.formatProject.月薪范围 !== '面议') {
        this.formatProject.月薪范围.map((n, idx) => {
          this.formatProject.月薪范围[idx] = parseInt(n) * 1000
        })
      }
      if (this.formatProject.工作经验 !== '不限') {
        this.formatProject.工作经验.map((n, idx) => {
          this.formatProject.工作经验[idx] = parseInt(n)
        })
      }
      this.loading = this.$loading({
        lock: true,
        text: '发布中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        target: '#push-to-yuanshou',
      })
      // this.formatProject.职位描述 += `\n${this.formatProject.职位吸引点}`
      if (this.type === 'new') {
        // this.formatProject.hunterId = [
        //   ...new Set(
        //     (this.rawProject.客户开发 || []).concat(
        //       this.rawProject.项目对接 || [],
        //       this.rawProject.项目经理 || [],
        //       this.rawProject.项目成员 || [],
        //     ),
        //   ),
        // ]
        const { data } = await app.service('wechat').externalApi({
          baseUrl,
          path: '/api/jobs/saveJob',
          method: 'POST',
          externalData: { jobData: JSON.stringify(this.formatProject), hunterIds: this.formatProject.hunterId },
        })
        if (data && data._id) {
          await this.getMpCode(data._id)
          setTimeout(() => {
            this.loading.close()
          }, 300)
          // this.$alert('发布成功', '提示', {
          //   confirmButtonText: '确定',
          //   callback: (action) => {
          //     this.dialogVisible = false
          //   },
          // })
        } else {
          this.$alert('发布出错,请重新操作', '提示', {
            confirmButtonText: '确定',
          })
        }
        this.$emit('new', this.formatProject)
      } else if (this.type === 'edit') {
        const { data } = await app.service('wechat').externalApi({
          baseUrl,
          path: '/api/jobs/updateJob',
          method: 'POST',
          externalData: { jobData: JSON.stringify(this.formatProject), ifReview: this.review },
        })
        if (data && data._id) {
          setTimeout(() => {
            this.loading.close()
            this.$alert('发布成功', '提示', {
              confirmButtonText: '确定',
              callback: (action) => {
                this.dialogVisible = false
              },
            })
          }, 300)
        } else {
          this.$alert('发布出错,请重新操作', '提示', {
            confirmButtonText: '确定',
          })
        }
        this.$emit('update', this.formatProject)
      }
    },
    showXiyin() {
      this.exampleVisible = true
      this.exampleTitle = '职位吸引点'
    },
    chooseXiyin(item) {
      this.formatProject.职位吸引点 = item
      this.exampleVisible = false
      this.exampleTitle = ''
    },
    showMiaoshu() {
      this.exampleVisible = true
      this.exampleTitle = '职位描述'
    },
    chooseMiaoshu(item) {
      this.formatProject.职位描述 = item
      this.exampleVisible = false
      this.exampleTitle = ''
    },
  },
}
</script>
<style>
.input-main-mini .el-input-group__append {
  padding: 0 10px;
}
.push-to-yuanshou > .el-dialog {
  margin: 0 auto;
  padding: 50px 0;
  height: 100vh;
  position: relative;
}
.push-to-yuanshou > .el-dialog > .el-dialog__header {
  position: absolute;
  top: 0;
  width: 100%;
  text-align: center;
  background: #fff;
  border-bottom: 1px solid #eee;
  transition: top ease-in 0.2s;
}
.push-to-yuanshou.title-hide > .el-dialog > .el-dialog__header {
  top: -137px !important;
}
.push-to-yuanshou > .el-dialog > .el-dialog__footer {
  position: absolute;
  width: 100%;
  bottom: 0;
  text-align: center;
  background: #fff;
  border-top: 1px solid #eee;
}
.push-to-yuanshou > .el-dialog > .el-dialog__body {
  background: #f2f2f2;
  height: 100%;
}
.push-inner-dia > .el-dialog > .el-dialog__body {
  padding: 0;
}
.push-inner-dia > .el-dialog > .el-dialog__header {
  background: #e8f3f9;
  color: #34457c;
}
.yuanshou-steps {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #313134;
  margin-top: 20px;
}
.yuanshou-step {
  width: 214px;
  margin: 0 10px;
}
.yuanshou-step-box {
  display: inline-block;
  border: 1px solid #313134;
  position: relative;
  top: -16px;
  font-size: 16px;
  line-height: 30px;
  padding: 0 10px;
  background: #fff;
  width: 214px;
}
.yuanshou-step-word {
  text-align: left;
}
.yuanshou-input-title {
  font-size: 16px;
  font-weight: bold;
}
.yuanshou-box {
  background: #ffffff;
  padding: 15px;
}
.yuanshou-input-label {
  font-size: 14px;
  font-weight: bold;
  padding: 10px 0 5px 0;
  width: 100%;
}
.yuanshou-input-label b {
  color: #ff5555;
  margin-right: 2px;
}
.yuanshou-input-item {
  padding: 5px 10px;
  color: #000;
}
.yuanshou-input-item .el-select,
.yuanshou-input-item .el-input {
  width: 100%;
}
.yuanshou-input-group {
  display: flex;
  align-items: center;
}
.yuanshou-tips {
  color: #bbb;
  font-size: 12px;
  font-weight: normal;
  line-height: 20px;
}
.yuanshou-tips-red {
  color: rgb(255, 102, 0);
}
.yuanshou-input-content {
  margin-bottom: 16px;
}
.yuanshou-text-btn {
  font-size: 12px;
  font-weight: normal;
  line-height: 20px;
  color: #409eff;
  cursor: pointer;
}
.yuanshou-icon-text {
  display: inline-flex;
  align-items: center;
  position: relative;
  top: 1px;
}
.input-main {
  border-radius: 5px;
}
.input-main-mini {
  width: 80px;
}
.fail .yuanshou-input-label {
  color: #ff5555 !important;
  position: relative;
}
.fail .yuanshou-input-label::after {
  content: attr(data-failObj);
  font-size: 12px;
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  background-color: rgba(0, 0, 0);
  color: #fff;
  align-items: center;
  padding: 10px;
}
.warning .yuanshou-input-label {
  color: #e6a23c;
  position: relative;
}
.warning .yuanshou-input-label::before {
  content: attr(data-warningObj);
  font-size: 12px;
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  background-color: rgba(0, 0, 0);
  color: #fff;
  align-items: center;
  padding: 10px;
}
.fail .input-main {
  border: 1px solid #ff5555 !important;
}
.warning .input-main {
  border: 1px solid#e6a23c;
}
</style>
<style scoped>
.more {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
}
.more span {
  display: block;
  font-size: 14px;
  font-weight: normal;
  margin-right: 5px;
}
.yuanshou-main {
  position: absolute;
  top: 190px;
  bottom: 65px;
  left: 15px;
  right: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}
.yuanshou-preview {
  width: 375px;
  background-color: #f9f9f9;
  position: absolute;
  top: 190px;
  bottom: 65px;
  right: 5px;
  overflow-y: auto;
  overflow-x: hidden;
}
.yuanshou-preview img {
  width: 100%;
  height: 100%;
  display: block;
}
.job-detail {
  width: 375px;
  background: rgba(255, 255, 255, 1);
  padding: 14px 20px;
  margin-bottom: 10px;
}
.job-detail-row {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.job-title {
  font-size: 21px;
  font-weight: 600;
  color: rgba(49, 49, 52, 1);
  line-height: 27px;
}
.job-salary {
  font-size: 17px;
  font-weight: 600;
  color: #e3c490;
  line-height: 24px;
}
.job-tags {
  font-size: 14px;
  color: #848484;
  line-height: 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.split {
  width: 2px;
  height: 24px;
  background: rgba(206, 206, 260, 1);
  margin: 0 20px;
}
.company-info {
  padding: 18px 20px 20px;
  margin-bottom: 10px;
  background: rgba(255, 255, 255, 1);
}
.company-content {
  font-size: 14px;
  color: rgba(107, 107, 107, 1);
  line-height: 1.8;
  white-space: pre-wrap;
  word-break: break-all;
}
.company-title {
  font-size: 17px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #313134;
  line-height: 24px;
  margin-bottom: 10px;
}
.company-desc {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #6b6b6b;
  line-height: 18px;
  margin-bottom: 20px;
}
.company-tags,
.job-detail-tags {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.company-tag,
.job-detail-tag {
  height: 26px;
  padding: 0 5px;
  background: #fdf8ee;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #e3c490;
  margin: 3px;
  border: 1px solid #e3c490;
}
.desc {
  background-color: #fff;
  padding: 20px;
  margin-bottom: 10px;
}
.desc-title {
  font-size: 18px;
  font-weight: 600;
  color: rgba(49, 49, 52, 1);
  line-height: 25px;
  position: relative;
  margin-bottom: 15px;
}
.desc-title::before {
  width: 3px;
  height: 20px;
  background: #cfad78;
  border-radius: 1px;
  position: absolute;
  left: -10px;
  top: 3px;
  content: '';
  display: block;
}
.desc-yaoqiu-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.desc-yaoqiu-item {
  width: 50%;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #6b6b6b;
  line-height: 20px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}
.desc-yaoqiu-item b {
  font-weight: 600;
  color: #313134;
}
.desc-content {
  font-size: 14px;
  color: rgba(107, 107, 107, 1);
  line-height: 1.8;
  white-space: pre-wrap;
  word-break: break-all;
}
.card {
  width: 356px;
  height: 160px;
  background: #ffffff;
  box-shadow: 0px 0px 4px 2px rgba(195, 195, 195, 0.5);
  border-radius: 5px;
  border: 1px solid #bdbdbd;
  position: relative;
  padding: 15px 11px;
  margin: 0 auto 10px;
}
.card-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card .company-title {
  margin-bottom: 11px;
}
.card-info {
  flex-grow: 1;
}
.card-icon {
  width: 92px;
  height: 92px;
  margin-right: 22px;
  flex-shrink: 0;
}
.card-name {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #313134;
  line-height: 22px;
  display: flex;
  align-items: center;
}
.card-wechat {
  width: 22px;
  height: 22px;
  margin-left: 10px;
}
.card-desc {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #6b6b6b;
  line-height: 19px;
  margin-top: 8px;
}
.input-wrap {
  flex-grow: 1;
  padding: 0 30px 0 5px;
  min-height: 28px;
  display: flex;
  align-items: center;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  flex-wrap: wrap;
  height: 40px;
  cursor: pointer;
}
.input-wrap .more {
  cursor: pointer;
  position: absolute;
  right: 20px;
}
.input-wrap:hover {
  border: 1px solid#C0C4CC;
}
.example-title {
  margin-left: 10px;
  color: rgb(255, 102, 0);
  font-size: 14px;
  margin-bottom: 20px;
}
.example-wrap,
.adv-wrap {
  display: flex;
  align-items: center;
}
.example-wrap {
  margin-bottom: 15px;
}

.adv-idx {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #3f3f3f;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  margin-right: 20px;
  flex-shrink: 0;
}
.example-wrap p {
  line-height: 1.8;
  font-size: 12px;
  white-space: pre-line;
  margin: 0 20px;
}

.yuanshou-main,
.yuanshou-preview {
  transition: top ease-in 0.2s;
}
.yuanshou-main-hide,
.yuanshou-preview-hide {
  top: 60px;
}
.jd-content-wrap {
  border: 1px solid #eee;
  border-radius: 16px;
  padding: 20px;
  white-space: pre-line;
}
</style>
